import axios from 'axios';

// REACT_APP_API_URL trỏ tới gốc /api của admin backend (vd. https://adminapi.caskback.vn/api).
// Mọi lời gọi dùng API v1: /api/v1/admin/... (xem docs/api-v1/openapi.yaml)
const API_ROOT = (process.env.REACT_APP_API_URL || 'http://localhost:3002/api').replace(/\/+$/, '').replace(/\/v1$/, '');
const API_BASE_URL = `${API_ROOT}/v1`;

export const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 0,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor để thêm token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('admin_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor để xử lý lỗi
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      // Token hết hạn hoặc không hợp lệ
      localStorage.removeItem('admin_token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;

/**
 * Danh sách có phân trang từ envelope v1 ({ data: [...], meta }) ->
 * { items, pagination: { page, limit, total, pages, totalPages }, ...field phụ trong meta (vd. summary) }
 */
export const toPage = (res) => {
  const { data, meta = {} } = res.data || {};
  const { page, limit, total_items: total, total_pages: pages, has_more: hasMore, next_cursor: nextCursor, ...extra } = meta;
  return {
    items: Array.isArray(data) ? data : [],
    pagination: { page, limit, total, pages, totalPages: pages, hasMore, nextCursor },
    ...extra
  };
};

/** Thông báo lỗi từ envelope v1 ({ error: { code, message } }) */
export const errorMessage = (err, fallback) =>
  err?.response?.data?.error?.message || fallback;
